// extracted by mini-css-extract-plugin
module.exports = {"beforeMigrationBanner":"_2Ozdk","title":"_3ooa5"};